import React, { useEffect } from "react";
import { WizardFormData } from "../types/wizard.types";

interface PointOfSalesStepProps {
  formData: WizardFormData;
  onFormUpdate: (data: Partial<WizardFormData>) => void;
  onValidationChange: (isValid: boolean) => void;
}

const PointOfSalesStep: React.FC<PointOfSalesStepProps> = ({
  onValidationChange,
}) => {
  useEffect(() => {
    onValidationChange(true);
  }, [onValidationChange]);

  return (
    <div className="tw-space-y-2">
      <div>
        <p className="tw-font-semibold tw-text-neutral-800">
          Sell Smarter, Not Harder
        </p>
        <p className="tw-pb-1 tw-text-neutral-800/80">
          Members buy directly, instantly boosting sales.
        </p>
      </div>
      <div>
        <p className="tw-font-semibold tw-text-neutral-800">
          Empower Your Team
        </p>
        <p className="tw-pb-1 tw-text-neutral-800/80">
          Free staff from admin, focus on coaching.
        </p>
      </div>
      <div>
        <p className="tw-font-semibold tw-text-neutral-800">
          Instant Member Convenience
        </p>
        <p className="tw-pb-1 tw-text-neutral-800/80">
          Seamless purchases, zero friction.
        </p>
      </div>
      <div>
        <p className="tw-font-semibold tw-text-neutral-800">
          Your Gym, Always Selling
        </p>
        <p className="tw-pb-1 tw-text-neutral-800/80">
          Maximize revenue, even when busy.
        </p>
      </div>
    </div>
  );
};

export default PointOfSalesStep;
